import React, { useEffect, useRef, useState } from "react";
import styles from "../BasicCleanupsFilter/BasicCleanupsFilter.module.scss";
import switchStyles from "../CleanupsFilter.module.scss";
import RepoweringBrownfieldFilter from "./RepoweringBrownfieldFilter/RepoweringBrownfieldFilter";
import RepoweringRCRAFilter from "./RepoweringRCRAFilter/RepoweringRCRAFilter";
import RepoweringSuperfundFilter from "./RepoweringSuperfundFilter/RepoweringSuperfundFilter";
import { CalciteButton, CalciteSwitch } from "@esri/calcite-components-react";

const RepoweringCleanupsFilter = (props) => {
  const brownfieldParams = useRef<Array<string>>([]);
  const rcraParams = useRef<Array<string>>([]);
  const superfundParams = useRef<Array<string>>([]);
  const [checkAllBoxes, setCheckAllBoxes] = useState<boolean>(true);
  const [signalAChange, setSignalAChange] = useState(Math.random());
  const [toggleOrClear, setToggleOrClear] = useState<string>("toggle");

  const updateBrownfieldParams = (paramArray) => {
    brownfieldParams.current = paramArray;
  };

  const updateRCRAParams = (paramArray) => {
    rcraParams.current = paramArray;
  };

  const updateSuperfundParams = (paramArray) => {
    superfundParams.current = paramArray;
  };

  const clearAllParams = (togglingFromSwitch: boolean) => {
    setCheckAllBoxes(false);
    setSignalAChange(Math.random());
    brownfieldParams.current = rcraParams.current = superfundParams.current = [];
    setToggleOrClear("clear");
    if (togglingFromSwitch) {
      props.generalClearAll();
    }
  }

  const toggleAllParams = (togglingFromSwitch: boolean) => {
    setCheckAllBoxes(true);
    setSignalAChange(Math.random());
    setToggleOrClear("toggle");
    if (togglingFromSwitch) {
      props.generalToggleAll();
    }
  }

  const createWhereString = () => {
    const paramArray: Array<string> = [
      ...brownfieldParams.current,
      ...rcraParams.current,
      ...superfundParams.current,
    ];
    if (paramArray.length > 0) {
      // const whereString: string = `(${paramArray.join(") OR (")})`;
      props.generalSetLayerViewFilter(`(${paramArray.join(") OR (")})`, 'repowering');
    } else {
      props.generalClearAll();
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {clearAllParams(false);}, [props.shouldClear])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {toggleAllParams(false);}, [props.shouldToggle]);

  useEffect(() => {}, [signalAChange])

  return (
    <div>
      <div className={switchStyles.controlsDiv}>
        <CalciteButton
          className={styles.FilterAndZoomButtons}
          onClick={() => {
            createWhereString();
          }}
          iconStart={"layer-filter"}
        >
          Filter
        </CalciteButton>
        <div className={switchStyles.toggleSwitchDiv}>
          <label className={switchStyles.toggleLabel}>
            Toggle All Cleanups
          </label>

          {toggleOrClear === "toggle" && (
            <CalciteSwitch
              checked
              onCalciteSwitchChange={() => {
                clearAllParams(true);
              }}
            />
          )}
          {toggleOrClear === "clear" && (
            <CalciteSwitch
              onCalciteSwitchChange={() => {
                toggleAllParams(true);
              }}
            />
          )}
        </div>
      </div>

      <div className={styles.SectionContainers}>
        <div className={styles.TopSectionInThirds}>
          <RepoweringBrownfieldFilter
            sitesLayer={props.sitesLayer}
            updateBrownfieldParams={updateBrownfieldParams}
            checkAllBoxes={checkAllBoxes}
            signalAChange={signalAChange}
          />
        </div>
        <div className={styles.TopSectionInThirds}>
          <RepoweringRCRAFilter
            sitesLayer={props.sitesLayer}
            updateRCRAParams={updateRCRAParams}
            checkAllBoxes={checkAllBoxes}
            signalAChange={signalAChange}
          />
        </div>
        <div className={styles.TopSectionInThirds}>
          <RepoweringSuperfundFilter
            sitesLayer={props.sitesLayer}
            updateSuperfundParams={updateSuperfundParams}
            checkAllBoxes={checkAllBoxes}
            signalAChange={signalAChange}
          />
        </div>
      </div>
    </div>
  );
};
export default RepoweringCleanupsFilter;
